const getBasePricePropsLegacy = (priceProps) => ({
  minimumFractionDigits: priceProps.minimumFractionDigits,
  culture: priceProps.locale,
  currency: priceProps.currency,
  vatInc: priceProps.vatInc,
  hideVatMessage: false,
  hideShippingMessageInVatMessage: false
});
const getBasePriceProps = (priceProps) => ({
  minimumFractionDigits: priceProps.minimumFractionDigits,
  locale: priceProps.locale,
  currency: priceProps.currency,
  vatInc: priceProps.vatInc
});
const getPricePerUnit = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    unitListPrice: prices.unitListPrice[taxInclusivity],
    unitDiscountPrice: prices.unitDiscountedPrice[taxInclusivity]
  };
};
const getQuantityPrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    quantity: priceProperties.quantity,
    listPrice: prices.totalListPrice[taxInclusivity],
    discountPrice: prices.totalDiscountedPrice[taxInclusivity]
  };
};
const getQuantityFromPrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    quantity: priceProperties.quantity,
    listPrice: prices.totalListPrice[taxInclusivity],
    discountPrice: prices.totalDiscountedPrice[taxInclusivity]
  };
};
const getRangedPrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    lowestListPrice: prices.lowestListPrice[taxInclusivity],
    highestListPrice: prices.highestListPrice[taxInclusivity],
    lowestDiscountPrice: prices.lowestDiscountPrice[taxInclusivity],
    highestDiscountPrice: prices.highestDiscountPrice[taxInclusivity]
  };
};
const getUnitRangedPrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    lowestListPrice: prices.lowestListPrice[taxInclusivity],
    highestListPrice: prices.highestListPrice[taxInclusivity],
    lowestDiscountPrice: prices.lowestDiscountPrice[taxInclusivity],
    highestDiscountPrice: prices.highestDiscountPrice[taxInclusivity]
  };
};
const getPriceForQuantityUnits = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    quantity: priceProperties.quantity,
    listPrice: prices.totalListPrice?.[taxInclusivity] ?? 0,
    discountPrice: prices.totalDiscountedPrice?.[taxInclusivity] ?? 0
  };
};
const getPriceWithQtyAndUnit = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    quantity: priceProperties.quantity,
    listPrice: prices.totalListPrice?.[taxInclusivity] ?? 0,
    discountPrice: prices.totalDiscountedPrice?.[taxInclusivity] ?? 0,
    unitListPrice: prices.unitListPriceForMoq?.[taxInclusivity] ?? prices.unitListPrice?.[taxInclusivity],
    unitDiscountPrice: prices.unitDiscountedPrice?.[taxInclusivity]
  };
};
const getPrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    listPrice: prices.totalListPrice[taxInclusivity],
    discountPrice: prices.totalDiscountedPrice[taxInclusivity]
  };
};
const getRawAndUnitPrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    listPrice: prices.totalListPrice[taxInclusivity],
    discountPrice: prices.totalDiscountedPrice[taxInclusivity],
    unitListPrice: prices.unitListPrice[taxInclusivity],
    unitDiscountPrice: prices.unitDiscountedPrice[taxInclusivity]
  };
};
const getAsLowAsPerPiecePrice = (prices, priceProperties) => {
  const taxInclusivity = priceProperties.vatInc ? "taxed" : "untaxed";
  return {
    ...getBasePricePropsLegacy(priceProperties),
    unitListPrice: prices.unitListPrice[taxInclusivity],
    unitDiscountPrice: prices.unitDiscountedPrice[taxInclusivity]
  };
};
const getPlusMinusPrice = (prices, priceProperties) => {
  return {
    priceDifference: priceProperties.isPriceNegative ? -Math.abs(prices.priceDifference) : prices.priceDifference,
    priceDifferenceDiscounted: priceProperties.isPriceNegative ? -Math.abs(prices.priceDifferenceDiscounted) : prices.priceDifferenceDiscounted,
    minimumFractionDigits: priceProperties.minimumFractionDigits,
    culture: priceProperties.locale,
    currency: priceProperties.currency,
    zeroDisplayType: priceProperties.zeroDisplayType,
    comparativeDisplayType: priceProperties.comparativeDisplayType
  };
};
const getCombinedPriceConfig = (prices, priceProperties) => {
  return {
    ...getBasePriceProps(priceProperties),
    listPrice: prices.totalListPrice,
    discountedListPrice: prices.totalDiscountedPrice,
    unitListPrice: prices.unitListPrice,
    unitDiscountedPrice: prices.unitDiscountedPrice,
    quantity: priceProperties.quantity
  };
};
const getDifferentialPriceConfig = (prices, priceProperties) => {
  return {
    ...getBasePriceProps(priceProperties),
    priceDifference: prices.priceDifference,
    priceDifferenceDiscounted: prices.priceDifferenceDiscounted,
    showComparativeDisplay: priceProperties.showComparativeDisplay,
    zeroDisplayType: priceProperties.zeroDisplayType
  };
};
const getDifferentialPriceForQuantityConfig = (prices, priceProperties) => {
  return {
    ...getBasePriceProps(priceProperties),
    priceDifference: prices.priceDifference,
    priceDifferenceDiscounted: prices.priceDifferenceDiscounted,
    quantity: priceProperties.quantity
  };
};
const getVatInfo = (priceProperties) => {
  return {
    culture: priceProperties.locale,
    vatInc: priceProperties.vatInc,
    hideShippingMessageInVatMessage: priceProperties.hideShippingMessageInVatMessage
  };
};

export { getAsLowAsPerPiecePrice, getCombinedPriceConfig, getDifferentialPriceConfig, getDifferentialPriceForQuantityConfig, getPlusMinusPrice, getPrice, getPriceForQuantityUnits, getPricePerUnit, getPriceWithQtyAndUnit, getQuantityFromPrice, getQuantityPrice, getRangedPrice, getRawAndUnitPrice, getUnitRangedPrice, getVatInfo };
//# sourceMappingURL=src-util-price-transform.js.map
